import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { ADMIN_ANEEL_TARIFFS_ENDPOINTS, AdminAneelTariffs } from "@/service/api/admin-aneel-tariffs";
import { ListAneelTariffsDto } from "@/service/dto/admin-aneel-tariffs";
import useToastOnError from "@/modules/common/hooks/useToastOnError";

const useAneelTariffList = (params: ListAneelTariffsDto) => {
  const query = useQuery({
    queryKey: [ADMIN_ANEEL_TARIFFS_ENDPOINTS.GET_TARIFFS, params],
    queryFn: () => AdminAneelTariffs.getTariffs(params),
    placeholderData: keepPreviousData,
    retry: false,
  });

  useToastOnError(query.isError, query.error, "Erro ao carregar tarifas ANEEL.");

  return query;
};

export default useAneelTariffList;
